import React from 'react';

const About: React.FC = () => {
  return (
    <section className="bg-[#050505] py-24 px-4 border-t border-white/5">
      <div className="max-w-4xl mx-auto text-center">
        <h2 className="text-3xl font-semibold text-white mb-8">关于我们</h2>
        <div className="prose prose-invert prose-lg mx-auto text-gray-400">
          <p className="mb-6">
            <strong className="text-white">森宇宙好绘</strong>是国内领先的“AI + 设计”商单交易平台。
          </p>
          <p>
            依托 5000+ 认证设计师资源与自研 AI 设计工具，为企业提供“高效、优质、低成本”的设计服务。
            同时也为设计师搭建“稳定、高佣、有保障”的接单渠道。<br />
            成立至今，已服务 1000+ 企业客户，促成 10万+ 交易，致力于成为“连接设计需求与创作能力”的专业桥梁。
          </p>
        </div>
      </div>
    </section>
  );
};

export default About;